import { privateApi, privateApiWithBlob } from "../api/axios";
import { ICustomerFile, IMission } from "../interfaces/crm";
import { ICreateInvoice } from "../interfaces/invoices";

// Dossier client
export const createCustomerFile = async (data: ICustomerFile) => {
    try {
        const response = await privateApi.post("api/customerfile", data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getCustomerFiles = async () => {
    try {
        const response = await privateApi.get("api/customerfile");
        return response;
    } catch (error) {
        throw error;
    }
}

export const getOneCustomerFile = async (id: number) => {
    try {
        const response = await privateApi.get(`api/customerfile/${id}`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const updateCustomerFile = async (id: number, data: ICustomerFile) => {
    try {
        const response = await privateApi.patch(`api/customerfile/${id}`, data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const deleteBillingContact = async (idCustomer: number, idContact: number) => {
    try {
        const response = await privateApi.delete(`api/customerfile/${idCustomer}/billingscontacts/${idContact}`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const handleDeleteCustomerFile = async (id: number) => {
    try {
        const response = await privateApi.delete(`api/customerfile/${id}`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getGeneralLedger = async (idCustomer: number) => {
    try {
        const response = await privateApi.get(`api/customerfile/${idCustomer}/generalledger`, { responseType: 'blob' });
        return response;
    } catch (error) {
        throw error;
    }
}

export const getInvoicesByCustomer = async (idCustomer: number) => {
    try {
        const response = await privateApi.get(`api/customerfile/${idCustomer}/invoices`);
        return response;
    } catch (error) {
        throw error;
    }
}

// Mission
export const createMission = async (idCustomer: number, data: IMission) => {
    try {
        const response = await privateApi.post(`api/customerfile/${idCustomer}/mission`, data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getMissions = async (idCustomer: number) => {
    try {
        const response = await privateApi.get(`api/customerfile/${idCustomer}/missions`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getMission = async (idCustomer: number, idMission: number) => {
    try {
        const response = await privateApi.get(`api/customerfile/${idCustomer}/mission/${idMission}`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const updateMission = async (idCustomer: number, idMission: number, data: IMission) => {
    try {
        const response = await privateApi.patch(`api/customerfile/${idCustomer}/mission/${idMission}`, data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const renewMission = async (idCustomer: number, idMission: number) => {
    try {
        const response = await privateApi.post(`api/customerfile/${idCustomer}/mission/${idMission}/renew`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const deleteMission = async (idCustomer: number, idMission: number) => {
    try {
        const response = await privateApi.delete(`api/customerfile/${idCustomer}/mission/${idMission}`);
        return response;
    } catch (error) {
        throw error;
    }
}

// Proforma
export const createProforma = async (idCustomer: number, idMission: number, data: ICreateInvoice) => {
    try {
        const response = await privateApi.post(`api/customerfile/${idCustomer}/mission/${idMission}/proforma`, data);
        return response;
    } catch (error) {
        throw error;
    }
}

// Production 
export const timeSpentPerCustomer = async (idCustomer: number, startDate: string, endDate: string ) => {
    try {
        const response = await privateApi.get(`api/customerfile/${idCustomer}/report/times?startDate=${startDate}&endDate=${endDate}`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getProductionByDepartement = async (idDepartment: number, date: string) => {
    try {
        const response = await privateApi.get(`api/customerfile/report/department?idDepartment=${idDepartment}&date=${date}`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getProductionBillingByMonth = async (startDate: string, endDate: string) => {
    try {
        const response = await privateApi.get(`api/customerfile/report/totalamounts?startDate=${startDate}&endDate=${endDate}`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getDocumentsByMission = async (idCustomer: number, idMission: number) => {
    try {
        const response = await privateApi.get(`api/customerfile/${idCustomer}/mission/${idMission}/invoices`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getCsvDocumentForProd = async (idCustomer: string, startDate: string, endDate: string) => {
    try {
        const response = await privateApi.get(`api/customerfile/${idCustomer}/report/times/csv?startDate=${startDate}&endDate=${endDate}`, { responseType: 'blob' });
        return response;
    } catch (error) {
        throw error;
    }
}

// Documents
export const postDocuments = async (idCustomer: number, data: FormData) => {
    try {
        const response = await privateApiWithBlob.post(`api/customerfile/${idCustomer}/documents`, data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getDocumentsByCustomer = async (idCustomer: number) => {
    try {
        const response = await privateApi.get(`api/customerfile/${idCustomer}/documents`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getDocumentByCustomer = async (idCustomer: number, idDoc: number) => {
    try {
        const response = await privateApiWithBlob.get(`api/customerfile/${idCustomer}/documents/${idDoc}`, { responseType: 'blob' });
        return response;
    } catch (error) {
        throw error;
    }
}

export const deleteDocumentByCustomer = async (idCustomer: number, idDoc: number) => {
    try {
        const response = await privateApi.delete(`api/customerfile/${idCustomer}/documents/${idDoc}`);
        return response;
    } catch (error) {
        throw error;
    }
}